import './style.scss'
import { Button } from 'antd'
import { FC, memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserStore } from '@/global-states'
import { CloseOutlined } from '@ant-design/icons'
import CheckLogin from '../CheckLogin'

const NewUserTip: FC = () => {
  const { t } = useTranslation()
  const { uid } = UserStore
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (uid) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }, [uid])

  if (!open) {
    return null
  }

  return (
    <CheckLogin>
      <div className="newuser-tip">
        <div className="title">{t('newuser_tip.title')}</div>
        <div className="desc">{t('newuser_tip.description')}</div>
        <Button className="btn" type="primary">
          {t('newuser_tip.register_button')}
        </Button>
        <CloseOutlined
          onClick={(e) => {
            e.stopPropagation()
            setOpen(false)
          }}
        />
      </div>
    </CheckLogin>
  )
}

export default memo(NewUserTip)
